export default "__VITE_ASSET__55f926e2__"